import {
  NavLink
} from "react-router-dom";

function Footer() {
  return (<div class="footer">&copy; 2025 Küstenspacken | <NavLink to="/contact">Impressum</NavLink></div>)
}

export default Footer